export const ADD_NEW_PROMOTION = 'ADD_NEW_PROMOTION';
export const UPDATE_TRANSLATE_PROMOTION = 'UPDATE_TRANSLATE_PROMOTION';
export const LOAD_PROMOTIONS = 'LOAD_PROMOTIONS';
export const SET_PROMOTION_FILTER = 'SET_PROMOTION_FILTER';
export const SET_PROMOTION_PAGINATION = 'SET_PROMOTION_PAGINATION';
export const SET_PROMOTION_SORT = 'SET_PROMOTION_SORT';
export const RESET_PROMOTION_FILTERS = 'RESET_PROMOTION_FILTERS';
export const LOAD_EDITABLE_PROMOTION = 'LOAD_EDITABLE_PROMOTION';
export const SET_EMPTY_EDITABLE_PROMOTION = 'SET_EMPTY_EDITABLE_PROMOTION';
export const ATTACH_RESELLERS_PRODUCT_GROUP_TO_PROMOTION = 'ATTACH_RESELLERS_PRODUCT_GROUP_TO_PROMOTION';
export const LOAD_SELL_PRICES_FOR_PROMOTION = 'LOAD_SELL_PRICES_FOR_PROMOTION';
export const EDIT_PROMOTION = 'EDIT_PROMOTION';
export const SET_SELL_PRICES_PAGINATION = 'SET_SELL_PRICES_PAGINATION';
export const SET_PROMOTION_SELL_PRICES_FILTER = 'SET_PROMOTION_SELL_PRICES_FILTER';
export const SET_PROMOTION_SELL_PRICES_SORT = 'SET_PROMOTION_SELL_PRICES_SORT';
export const RESET_PROMOTION_SELL_PRICES_FILTERS = 'RESET_PROMOTION_SELL_PRICES_FILTERS';
export const SET_EMPTY_SELL_PRICES = 'SET_EMPTY_SELL_PRICES';
export const SAVE_PROMO_TO_CUSTOMIZE = 'SAVE_PROMO_TO_CUSTOMIZE';
export const SET_EMPTY_PROMO_TO_CUSTOMIZE = 'SET_EMPTY_PROMO_TO_CUSTOMIZE';
export const ATTACH_SELLPRICES_TO_PROMOTION = 'ATTACH_SELLPRICES_TO_PROMOTION';
export const LOAD_PROMOTION_SELLPRICES = 'LOAD_PROMOTION_SELLPRICES';
export const UPDATE_SELL_PRICES = 'UPDATE_SELL_PRICES';
export const DELETE_SELL_PRICES = 'DELETE_SELL_PRICES';
export const SET_PROMO_SELL_PRICES_FILTER = 'SET_PROMO_SELL_PRICES_FILTER';
export const SET_PROMO_SELL_PRICES_PAGINATION = 'SET_PROMO_SELL_PRICES_PAGINATION';
export const RESET_PROMO_SELL_PRICES_FILTERS = 'RESET_PROMO_SELL_PRICES_FILTERS';
export const SET_DISABLE_PROMOTION = 'SET_DISABLE_PROMOTION';
